import React from 'react';
import { Modal } from 'antd';
import {
  getTPStatusByTpid,
  GetTPStatusByTpidParams,
} from 'services/thirdParty';
import { useQuery } from 'react-query';
import { isEmpty } from 'lodash';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';

export type StatusModalProps = {
  record?: any;
  onClose?: any;
  visible: boolean;
  params: GetTPStatusByTpidParams;
  refetchProp?: boolean;
};

const StatusModal = ({
  onClose,
  visible = false,
  params,
  refetchProp,
  ...otherProps
}: StatusModalProps) => {
  const { data, } = useQuery(
    ['getTPStatusByTpid', params,refetchProp],
    () => getTPStatusByTpid(params).then((res) => res.list || []),
    { enabled: !isEmpty(params)||undefined }
  );

  const columns: DataGridColDef<any>[] = [
    // {
    //   comcode: 'tpstatustype',
    //   dataIndex: 'tpstatustype',
    //   width: 100,
    // },
    {
      comcode: 'username',
      dataIndex: 'username',
      width: 100,
    },
 
   
    {
      comcode: 'startdate',
      dataIndex: 'startdate',
      width: 100,
    },
    {
      comcode: 'enddate',
      dataIndex: 'enddate',
      width: 100,
    },
      
    {
      comcode: 'statusdate',
      dataIndex: 'statusdate',
      width: 100,
    },
    {
      comcode: 'statuslabel',
      dataIndex: 'statuslabel',
      render: (value,record) => (record.statuslabel ?? record.status),
      width: 100,
    },
  ];

  return (
    <Modal
      visible={visible}
      title="OverallStatus"
      width="1200px"
      style={{ top: 200 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
      }}
    >
      <DataGrid
        rowKey={(record) => record.tpstatusid}
        dataSource={data}
        columns={columns}
        {...otherProps}
      />
    </Modal>
  );
};

export default StatusModal;
